/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RvuGpciDetailsViewModel } from './rvuGpciDetailsViewModel';

export interface RvuGpciViewModel {
  id?: string;
  mac?: string | null;
  stateCode?: string | null;
  localityNumber?: string | null;
  localityName?: string | null;
  rvuGpciDetails?: Array<RvuGpciDetailsViewModel> | null;
}
